var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.num >= 0 ? 'red' : 'green']},[_vm._v(" "+_vm._s(_vm.c_num)+_vm._s(_vm.unit)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }